export default `:host {}`